
// Format default (lokal Indonesia)
String.prototype.toFormattedDate = function (locale = "id-ID", options) {
    try {
        const date = new Date(this);
        if (isNaN(date.getTime())) return null;

        return date.toLocaleDateString(
            locale,
            options || { day: "2-digit", month: "long", year: "numeric" }
        );
    } catch {
        return this;    
    }
};

// Custom format (YYYY-MM-DD)
String.prototype.toCustomDate = function () {
    const d = new Date(this);
    if (isNaN(d.getTime())) return null;

    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const da = String(d.getDate()).padStart(2, "0");

    return `${y}-${m}-${da}`;
};

// String.prototype.toFormatCurrency = function (prefix = "Rp. ", suffix = "") {
//     try {
//         const number = Number(this);
//         if (typeof number !== "number" || isNaN(number)) return "";

//         // Pisahkan integer dan decimal
//         const [integer, decimal] = number.toString().split(".");

//         // Format bagian integer dengan titik setiap 3 digit
//         const formattedInt = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

//         // Kalau ada decimal → gabungkan lagi
//         return decimal ? `${prefix} ${formattedInt},${decimal}` : `${prefix}${formattedInt}${suffix}`;
//     } catch {
//         return this;
//     }
// };

function formatCurrency(value, prefix = "Rp. ", suffix = "") {
  try {
    const number = Number(String(value).replace(/[^0-9.-]/g, ""));
    if (isNaN(number)) return "";

    const [integer, decimal] = String(value).split(".");

    const formattedInt = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    const formatted =
      decimal !== undefined
        ? `${prefix}${formattedInt},${decimal}${suffix}`
        : `${prefix}${formattedInt}${suffix}`;

    return formatted.trim();
  } catch (e) {
    console.error("formatCurrency error:", e);
    return value;
  }
}

if (!String.prototype.toFormatCurrency) {
  String.prototype.toFormatCurrency = function (prefix = "Rp. ", suffix = "") {
    return formatCurrency(this, prefix, suffix);
  };
}

if (!Number.prototype.toFormatCurrency) {
  Number.prototype.toFormatCurrency = function (prefix = "Rp. ", suffix = "") {
    return formatCurrency(this, prefix, suffix);
  };
}

